import { render, staticRenderFns } from "./productTaskList.vue?vue&type=template&id=ea3dde12&scoped=true&"
import script from "./productTaskList.vue?vue&type=script&lang=js&"
export * from "./productTaskList.vue?vue&type=script&lang=js&"
import style0 from "./productTaskList.vue?vue&type=style&index=0&id=ea3dde12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3dde12",
  null
  
)

export default component.exports